export default "__VITE_PUBLIC_ASSET__9a4f312a__"